import React from "react";
import { Box } from "@chakra-ui/react";

const VideoBlockPreview = ({ block }) => {
   
    return (
        <Box
            style={{ marginTop: block.props.marginTop + "px", marginRight: block.props.marginRight + "px", marginBottom: block.props.marginBottom + "px", marginLeft: block.props.marginLeft + "px" }}
        >
            {/* <video src={`${block.props.videoUrl}`} controls width="100%" height="100%" /> */}

            <iframe
                width="100%"
                height="200"
                src={`${block.props.videoUploadLink}`}
                title="video preview"
                allowFullScreen
            ></iframe>
        </Box>
    );
};

export default VideoBlockPreview;